import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: (p) => p.spacing(0.5),
  color: (p) => p.palette.primary[700],
};
